<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Profit</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Profit</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							
							
							<div class="row">
								<div class="col-md-12">
									<div class="card dash-card">
										<div class="card-body">
											<div class="row">
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
														<div class="circle-bar circle-bar2">
														    <img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-gift-essentials-icongeek26-outline-gradient-icongeek26.png"/>
                                                        </div>
														<div class="dash-widget-info">
															<h6>Total Komisi</h6>
															<h3>{{wallet.total_profit}}</h3>
															<!-- <p class="text-muted">2021 2022</p> -->
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget dct-border-rht">
														<div class="circle-bar circle-bar3">
															<img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-wallet-essentials-icongeek26-outline-gradient-icongeek26.png"/>
														</div>
														<div class="dash-widget-info">
															<h6>Sisa Komisi belum dicairkan</h6>
															<h3>{{wallet.sisa_saldo}}</h3>
															<!-- <p class="text-muted">2021 2022</p> -->
														</div>
													</div>
												</div>
												
												<div class="col-md-12 col-lg-4">
													<div class="dash-widget">
														<div class="circle-bar circle-bar3">
															<img src="https://img.icons8.com/external-icongeek26-outline-gradient-icongeek26/64/000000/external-bank-essentials-icongeek26-outline-gradient-icongeek26.png"/>
                                                            </div>
														<div class="dash-widget-info">
															<h6>Total Komisi Dicairkan</h6>
															<h3>{{wallet.total_cair}}</h3>
															<!-- <p class="text-muted">2021 - 2022</p> -->
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12">

									<div class="card">
                                        <div class="card-body">
                                            <div class="sender-widget">
                                                <div class="doc-info-left">
                                                    <div class="doc-info-cont">
                                                        <h6 class="doc-name">Ayo ajak teman-temanmu belajar di PejuangPendidik !!!</h6>
                                                        <div class="shop-details">
                                                            <p class="doc-location">segera share kode referralmu, dan dapatkan komisi yang menguntungkan :)</p>
                                                        </div> 
                                                        <p class="doc-department"><img src="@/assets/img/specialities/specialities-05.png" class="img-fluid" alt="Speciality">Kode Refferalmu : <b>{{kode_referral}}</b></p>
                                                        <!-- <div class="rating">
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star filled"></i>
                                                            <i class="fas fa-star"></i>
                                                            <span class="d-inline-block average-rating">(35)</span>
                                                        </div>
                                                        <div class="shop-details">
                                                            <p class="doc-location"><i class="fas fa-map-marker-alt"></i> Newyork, USA - <a href="javascript:void(0);">Get Directions</a></p>
                                                        </div> -->
                                                        <!-- <div class="shop-services">
                                                            <span>Copy Kode Refferal</span>
                                                            <span>Share Link Referral</span>
                                                            <span>Ajukan Penarikan profit</span>
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <div class="doc-info-right">
                                                    <div class="clini-infos">
                                                        <ul>
                                                            <!-- <li><button class="btn btn-sm btn-secondary mb-0.5"  @click.prevent="getMateri(item)">Copy Refferal</button></li> -->
                                                            <li><button class="btn btn-sm bg-primary-light mb-0.5"   v-clipboard:copy="link_referral" v-clipboard:success="onCopy" >Copy Link Refferal</button></li>
                                                            <li><button class="btn btn-sm bg-warning-light mb-0.5" data-toggle="modal" data-target="#penarikanMdl" @click.prevent="resetPenarikan(null)">Ajukan penarikan</button></li>
                                                           
                                                        </ul>
                                                    </div>
                                                    <!-- <div class="sender-action">
                                                        <a href="javascript:void(0)" class="btn btn-white fav-btn">
                                                            <i class="far fa-bookmark"></i>
                                                        </a>
                                                        <router-link to="/instructor/chat" class="btn btn-white msg-btn">
                                                            <i class="far fa-comment-alt"></i>
                                                        </router-link>
                                                        <a href="javascript:void(0)" class="btn btn-white call-btn" data-toggle="modal" data-target="#voice_call">
                                                            <i class="fas fa-phone"></i>
                                                        </a>
                                                        <a href="javascript:void(0)" class="btn btn-white call-btn" data-toggle="modal" data-target="#video_call">
                                                            <i class="fas fa-video"></i>
                                                        </a>
                                                    </div>  -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card card-table mb-0">
                                        <div class="card-body">
                                            <div class="table-responsive">
                                                <table id="tblTransaksi" class="table table-hover table-center mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-left">#</th>
                                                            <th class="text-ceter">Tanggal Transaksi</th>
                                                            <th class="text-center">Nominal</th>
                                                            <th class="text-center">Keterangan</th>
                                                            <th class="text-center">Jenis Transaksi</th>
                                                            <th class="text-center">Status</th>
                                                            <th class="text-left">Action</th>
                                                        </tr>
                                                    </thead>
                                
                                                    <tbody>
                                                        <tr v-for="(ref, index) in lsttransaksi" :key="ref.id">
                                                            <td>{{ index + 1 }}</td>
                                                            <td>{{ ref.tgl_transaksi }}</td>
                                                            <td class="text-right">{{ ref.nilai_transaksi_lbl }}</td>
                                                            <td>{{ ref.keterangan }}</td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_status == '1' || ref.fg_status == '2'  , 'bg-success-light' : ref.fg_status == '2'}">{{ref.status_nm}}</span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.fg_approval == '0' , 'bg-success-light' : ref.fg_approval == '1', 'bg-danger-light' : ref.fg_approval == '2' }">{{ref.approval_nm}}</span>
                                                            </td>
                                                            
                                                            <td>
                                                                <template v-if="ref.fg_approval == '0' && ref.fg_status != '1'">
                                                                    <v-btn class="btn btn-sm bg-danger-light" depressed small data-toggle="modal" data-target="#penarikanMdl" @click.prevent="resetPenarikan(ref)">
                                                                    Edit
                                                                    </v-btn>
                                                                </template>
                                                            </td>
                                                        
                                                        </tr>
                                                    </tbody>                                            
                                                </table>
                                            
                                            </div>
                                        </div>
                                    </div>
                            
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>

    
        <div id="penarikanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Form Penarikan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form id="frm" @submit.prevent="savePenarikan">                            
                    <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Saldo Tersedia</label>
                                        <input class="form-control" type="text" v-model="wallet.sisa_saldo" disabled="disabled">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nominal Penarikan</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.nilai_transaksi" @input="updateNet" v-bind="number" required="required"></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Biaya Transfer</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.fee_transfer" v-bind="number" readonly></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Net Transfer</label>
                                        <!-- <input class="form-control" type="text" v-model="walletdtl.nilai_transaksi"> -->
                                        <number class="form-control" v-model="walletdtl.net_transfer" v-bind="number" readonly></number>

                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Bank</label>
                                        <input class="form-control" type="text" v-model="walletdtl.pnama_bank" required="required">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>No Rekening</label>
                                        <input class="form-control" type="text" v-model="walletdtl.pno_rekening" required="required">
                                    </div>
                                </div>
                                
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Pemilik Rekening</label>
                                        <input class="form-control" type="text" v-model="walletdtl.patas_nama" required="required">
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section text-center">
                            <button class="btn btn-primary submit-btn" type="submit">Submit</button>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
		<!-- /Main Wrapper -->
</template>

<script>
import Sidebar from '../Sidebar';
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'ProfileSetting',
	data() {
		return {
            kode_referral: '',
            link_referral: '',
			number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
			wallet: {
                total_profit:'',
                sisa_saldo:'',
                total_cair:''
            },
            walletdtl: {
                id:'',
                nilai_transaksi: 0,
                pno_rekening: '',
                patas_nama: '',
                pnama_bank: '',
                fee_transfer: 5550,
                net_transfer: 0
            },
            lsttransaksi:[]
		}
	},
	
    created: function () {
        this.getAll();
        this.kode_referral = localStorage.getItem("kodeRef");
        this.link_referral = window.location.origin+"/referral?koderef="+localStorage.getItem("kodeRef");
    },
	methods: {
        
        updateNet: function () {
                if(parseInt(this.walletdtl.nilai_transaksi) > 0){
                    this.walletdtl.net_transfer = parseInt(this.walletdtl.nilai_transaksi) - parseInt(this.walletdtl.fee_transfer);            
                }
        },

        onCopy: function (e) {
            // alert('You just copied the following text to the clipboard: ' + e.text)
            let timerInterval
            swal.fire({
            title: 'link Referral',
            html: 'Link Referral berhasil dicopy!',
            timer: 1000,
            // icon: 'success',
            timerProgressBar: true,
            didOpen: () => {
                swal.showLoading()
                const b = swal.getHtmlContainer().querySelector('b')
                timerInterval = setInterval(() => {
                b.textContent = swal.getTimerLeft()
                }, 100)
            },
            willClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === swal.DismissReason.timer) {
                console.log('I was closed by the timer')
            }
            })
            
        },
        
        updateValue(event) {
        // const value = event.target.value
        // console.log(value, this.amount)
        // console.log(this.walletdtl.nilai_transaksi);
        if (parseInt(this.walletdtl.nilai_transaksi) > parseInt(this.wallet.sisa_saldo) || parseInt(this.walletdtl.nilai_transaksi) < 0) {
            // this.amount = value
            this.walletdtl.nilai_transaksi = 0;
            // this.$forceUpdate()
        }
        },

		initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        goToBeliPaket(){
            this.$router.push({name:'siswa-paket-belajar'}); 
        },

        resetPenarikan(ref){
            if(ref != null){
                this.walletdtl =  ref;
            } else {
                this.walletdtl =  {
                    nilai_transaksi: 0,
                    pno_rekening: '',
                    patas_nama: '',
                    pnama_bank: '',
                    fee_transfer: 5550,
                    net_transfer:0
                };
            }
        },

        //--------------------------
        // Get Wallet
        getAll: function () {
            axios.get('api/walletuser')
                .then(res => {
                    this.wallet = res.data.data;  
                    if(this.wallet.list_transaksi.length){ 
                        this.clearTbl("tblTransaksi");
                        this.lsttransaksi = this.wallet.list_transaksi;
                        this.initDt("tblTransaksi");
                    }
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        savePenarikan: function () {
            // console.log("cek isi");
            // console.log(parseInt(this.walletdtl.nilai_transaksi));
            // console.log(parseInt(this.wallet.saldo));
            if (parseInt(this.walletdtl.nilai_transaksi) > parseInt(this.wallet.saldo) || parseInt(this.walletdtl.nilai_transaksi) < 0) {
                
                 let timerInterval
                    swal.fire({
                    title: 'Peringatan',
                    html: '<div class="success-cont">'+
                                '<i class="fas fa-times"></i>'+
                                '<h3>Nilai Transaksi tidak boleh lebih dari Sisa saldo!</h3>'+
                                // '<p>Nilai yang anda dapatkan adalah <strong> '+this.tryout.hasil+'</strong></p>'+
                                // '<router-link to="/admin/tryout" class="btn btn-primary view-inv-btn">Selesai</router-link>'+
                            '</div>',
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                        
                    })
            } else{

                axios.post('api/walletpenarikan', {
                        walletdtl: this.walletdtl
                    })
                    .then(res => {
                        // handle success
                        this.getAll();
                        this.resetPenarikan(null);
                        $("#penarikanMdl").modal('hide');
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            }
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/Wallet/index.vue